import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { IArticle, IContent } from "types";
import { currentContentLang } from "i18n";

export { useChimeVideo } from './useChimeVideo';

const FALLBACK_LANG = "zh-TW";

// 依語系載入衛教內容 JSON；非中文語系若該檔尚未機翻（缺檔 / 回傳非 JSON）則退回 zh-TW
async function fetchContentJson(lang: string, file: string) {
  if (lang !== FALLBACK_LANG) {
    try {
      const res = await fetch(`/json/${lang}/${file}`);
      if (res.ok) {
        return await res.json();
      }
    } catch (error) {
      // 缺檔或非 JSON（SPA fallback 回 index.html）→ 落到下方 zh-TW
    }
  }
  const res = await fetch(`/json/${FALLBACK_LANG}/${file}`);
  return await res.json();
}

export const useGetArticleList = (hash) => {
  useTranslation(); // 訂閱語系切換，切換後重新載入對應語系內容
  const lang = currentContentLang();
  const [articleList, setArticleList] = useState<IArticle[]>([]);
  const file = `articleList${hash.substring(1)}.json`;

  useEffect(() => {
    const getArticleList = async () => {
      try {
        const data = await fetchContentJson(lang, file);
        setArticleList(data);
      } catch (error) {
        console.log(error);
      }
    };
    getArticleList();
  }, [file, lang]);

  return { articleList };
};

export const useGetContentData = (uuid: string) => {
  useTranslation(); // 訂閱語系切換
  const lang = currentContentLang();
  const [contentData, setContentData] = useState<IContent | null>(null);

  useEffect(() => {
    const getContentData = async () => {
      try {
        const data = await fetchContentJson(lang, "contents.json");
        // 從陣列中找到對應的 id(uuid) 資料
        const foundContent = data.find((item: IContent) => item.id === uuid);
        setContentData(foundContent || null);
      } catch (error) {
        console.log(error);
      }
    };

    if (uuid) {
      getContentData();
    }
  }, [uuid, lang]);

  return { contentData };
};
